import './PageFooter.css';

/**
 * Page Footer Component
 * Displays the NYUFAZ logo in the footer
 */
const PageFooter = () => {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-logo-container">
          <span className="powered-by-text">Powered by</span>
          <a href="https://nyufaz.com/" aria-label="Visit NYUFAZ website">
            <img
              src={`${process.env.PUBLIC_URL}/logo.svg`}
              alt="NYAFAZ logo"
              className="footer-logo"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default PageFooter;
